import FilterSettings from "./../constants"

// TODO: technically the values should be arrays since object orders aren't gauranteed, 
// but I've honestly never seen it be a problem with static variables. 
      
var DestinationSettings = {
  view: {
    selected: "grid-view",
    values: {
      "grid-view": "Grid View",
      "list-view": "List View",
      "map-view": "Map View"
    },
    icons: {
      "grid-view": "fa-th",
      "list-view": "fa-th-list",
      "map-view": "fa-map"
    }
  }, 
  sort: {
    selected: "rank",
    values: {
      "rank": "Popularity", 
      "alphabetical": "Alphabetically"
    },
    icons: {
      "rank": "fa-sort-numeric-asc",
      "alphabetical": "fa-sort-alpha-asc"
    }
  },
  filter: {
    selected: [],
    values: FilterSettings.labelMap
  },
};


module.exports = DestinationSettings;



// WEBPACK FOOTER //
// ./components/guide-components/destination-settings.js